import React from "react";
import { FaRegTimesCircle } from "react-icons/fa";

interface PopupDialogProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    className?: string; // Add optional className prop
    maxWidth?: string; // Add optional maxWidth prop
}

const AddDialog: React.FC<PopupDialogProps> = ({
    title,
    isOpen,
    onClose,
    children,
    className = "",
    maxWidth = "max-w-md" // Default to medium width
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/30 backdrop-blur-sm z-50 p-4">
            <div className={`bg-white rounded-lg shadow-xl relative w-full ${maxWidth} ${className}`}>
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors p-1"
                    >
                        <FaRegTimesCircle size={24} />
                    </button>
                </div>

                {/* Dynamic Content */}
                <div className="max-h-[80vh] overflow-y-auto p-10">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AddDialog;